import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { TEAM } from "@/data/content";

export default function Team() {
  const { t } = useLang();

  return (
    <section id="team" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="flex items-center gap-3 font-mono-brand text-xs tracking-[0.28em] uppercase text-gold mb-5">
            <span className="h-px w-10 bg-gold/70" />
            {t("team.eyebrow")}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-navy-900">
            {t("team.title")}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{t("team.sub")}</p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEAM.map((member, i) => (
            <motion.article
              key={member.name}
              data-testid={`team-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-3xl card-navy card-navy-hover ${
                member.ceo ? "ring-1 ring-gold/50" : ""
              }`}
            >
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={member.img}
                  alt={member.name}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[900ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/20 to-transparent" />
                {member.ceo && (
                  <span className="absolute top-4 left-4 rounded-full bg-gold px-3.5 py-1.5 text-[11px] font-bold tracking-widest uppercase text-navy-950">
                    CEO
                  </span>
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-display text-2xl text-slate-50">{member.name}</h3>
                <p className="mt-1 text-sm text-gold">{t(member.roleKey)}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
